import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

/**
 * Popup control.
 */
class PopupControl extends HTMLControl {
  initialize() {
    this.hidden = true;
    this.classList.add('popup');
    this.parentNode.classList.add('popup-container');
    super.initialize();
  }

  static get markup() {
    return `
<div class='popup-caret'>
  <div class='popup-caret-outer'></div>
  <div class='popup-caret-inner'></div>
</div>
<div class='popup-content'></div>
`;
  }

  get open() {
    return this._open;
  }
  set open(val) {
    this._open = val;

    let availableArea;
    if (this._open) {
      availableArea = this.getAvailableArea();
    }

    this.hidden = !this._open;
    this._open
      ? this.parentNode.setAttribute('open', 'true')
      : this.parentNode.removeAttribute('open');

    if (this._open) {
      let listRect = this.getBoundingClientRect();
      if (listRect.right - availableArea.width > 0) {
        this.style.right = `0px`;
      }

      if (listRect.bottom > availableArea.height) {
        this.classList.add('popup-up');
      } else {
        this.classList.remove('popup-up');
      }
    }
  }

  get innerHTML() {
    return this.contentElement.innerHTML;
  }
  set innerHTML(val) {
    this.contentElement.innerHTML = val;
  }

  getAvailableAreaElement() {
    // Workaround: overflow container element clips absolute positioned
    // content contained by a relative position parent. If an overflow
    // container element is present, then show the popup in its boundaries.
    let grandParent = this.parentElement?.parentElement;
    for (
      let el = grandParent;
      el && el != this.ownerDocument.body;
      el = el.parentElement
    ) {
      let style = window.getComputedStyle(el);
      if (style.overflowX != 'visible' || style.overflowY != 'visible') {
        return el;
      }
    }
    return null;
  }

  getAvailableArea() {
    let availableAreaElement = this.getAvailableAreaElement();
    if (availableAreaElement) {
      return {
        width: availableAreaElement.clientWidth,
        height: availableAreaElement.clientHeight,
      };
    }
    return { width: window.innerWidth, height: window.innerHeight };
  }

  static selectors = {
    Content: '.popup-content',
  };

  static elements = {
    contentElement: this.selectors.Content,
  };
}

window.customElements.define('popup-control', PopupControl);

export { PopupControl };
